import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const REVIEW_PAGE_REQUEST = 'REVIEW_PAGE_REQUEST';
export const REVIEW_PAGE_SUCCESS = 'REVIEW_PAGE_SUCCESS';
export const REVIEW_PAGE_ERROR = 'REVIEW_PAGE_ERROR';

export function reviewPageRequestAction() {
	return { type: REVIEW_PAGE_REQUEST };
}

export function reviewPageSuccessAction(data) {
	return { type: REVIEW_PAGE_SUCCESS, data };
}

export function reviewPageErrorAction(error) {
	return { type: REVIEW_PAGE_ERROR, error };
}

export function fetchReviewPageDataAction(pid) {
	return dispatch => {
		dispatch(reviewPageRequestAction());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/3/reviews/product/detail?pid=${pid}`
			})
		).then(
			data => dispatch(reviewPageSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(reviewPageErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
